/**
 * Helpers de pantalla completa. Safari todavía usa los prefijos webkit, así que
 * los tres contemplan las dos variantes y no rompen nada si el navegador no
 * soporta la API (por ejemplo dentro de un iframe sin permiso).
 */

/** Elemento que está en pantalla completa, o null si no hay ninguno */
export function fullscreenElement(): Element | null {
  const doc: any = document;
  return doc.fullscreenElement || doc.webkitFullscreenElement || null;
}

/**
 * Manda un elemento a pantalla completa. Si el navegador no lo permite, la
 * pantalla se queda como estaba.
 * @param element Elemento a expandir
 */
export function requestFullscreen(element: any): void {
  const request = element?.requestFullscreen || element?.webkitRequestFullscreen;
  request?.call(element)?.catch?.(() => {});
}

/** Sale de pantalla completa */
export function exitFullscreen(): void {
  const doc: any = document;
  const exit = doc.exitFullscreen || doc.webkitExitFullscreen;
  exit?.call(doc)?.catch?.(() => {});
}
